export default "__VITE_ASSET__z9TqdmGt__"